import Text from '@root/components/v2/ui-elements/Text';
import Tooltip from '@root/components/v2/ui-elements/Tooltip';

// Cell renderers shared by the dashboard's top-5 table cards (see ./tableCardColumns).

const SINGLE_LINE = { minWidth: 0, width: '100%' };

export const TruncatedText = ({ value, tooltip = value }) => (
  <Tooltip title={tooltip} placement="top">
    <Text font="medium" className="SingleLine" style={SINGLE_LINE}>
      {value ?? '-'}
    </Text>
  </Tooltip>
);
